import React from 'react'

import LinearProgress from '@mui/material/LinearProgress'

import styles from './Block.module.scss'

const Block = ({ title, count, percent }) => {
    return (
        <li className={styles.statisticsBlockListItem}>
            <div className={styles.statisticsMainBlockWrapper}>
                <p className={styles.statisticsMainBlockTitle} title={title}>
                    {title}
                </p>
                <div className={styles.statisticsMainBlockValues}>
                    {count}
                    {!!percent && <span>({percent}%)</span>}
                </div>
            </div>
            <LinearProgress
                className={styles.statisticsMainLinearProgress}
                classes={{ bar: styles.statisticsMainLinearProgressBar }}
                variant="determinate"
                value={percent || 0}
            />
        </li>
    )
}

export default Block
